<template>
  <div class="training-batch-setting-main"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="detailInfo">
      <!-- 左侧列表 -->
      <div class="side">
        <div class="header">
          <!-- 批次名称 -->
          <div class="batch-name">
            <span class="label">批次：</span>
            <span class="name">{{ detailInfo.batchName }}</span>
          </div>
          <!-- 教学点标题 -->
          <div class="title">
            <span>教学点（{{ getSites ? getSites.length : 0 }}）</span>
          </div>
          <!-- 默认配置按钮 -->
          <div class="empty">
            <el-radio-group v-model="currentSiteId">
              <el-radio-button label="">
                <i class="el-icon-setting"></i>
                <span>默认配置</span>
              </el-radio-button>
            </el-radio-group>
          </div>
          <!-- 搜索框 -->
          <div class="input">
            <el-input v-model="keyword"
                      size="mini"
                      clearable
                      placeholder="搜索教学点..."/>
          </div>
        </div>
        <div class="body">
          <div class="body-cont">
            <template v-if="getSites && getSites.length">
              <AppScrollbar style="height: 100%">
                <div class="site-list">
                  <el-radio-group v-model="currentSiteId">
                    <el-radio-button v-for="site in getSites"
                                     :key="site.id"
                                     :label="site.id"
                                     class="theme-light-bg-active">
                      <div class="label">{{ site.name }}</div>
                      <div class="extra">
                        <el-tag v-if="site.configured"
                                size="mini"
                                type="primary">已设置</el-tag>
                        <el-tag v-else
                                size="mini"
                                type="info">未设置</el-tag>
                      </div>
                    </el-radio-button>
                  </el-radio-group>
                </div>
              </AppScrollbar>
            </template>
            <template v-else>
              <Hint type="empty">
                <div v-if="keyword">没有匹配的教学点</div>
                <div v-else>没有可配置教学点</div>
              </Hint>
            </template>
          </div>
        </div>
      </div>
      <!-- 右侧配置区 -->
      <div class="main">
        <div class="main-cont">
          <keep-alive>
            <component :key="batchId + '_' + currentSiteId"
                       :is="getComponent"
                       :batch-id="batchId"
                       :site="getCurrentSite"
                       @configure-change="onConfigureChange"/>
          </keep-alive>
        </div>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading" type="error">
        <div>配置数据加载失败</div>
        <el-button type="text" @click="loadDetailInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../elements/AppScrollbar'
import TrainingBatchSettingConfigure from './configure'
import TrainingBatchSettingConfigureCustom from './configure/custom'
import Hint from '../../../../../../elements/Hint'

export default {
  name: 'TrainingBatchSettingMain',
  components: { AppScrollbar, Hint },
  props: {
    batchId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      detailInfo: null,
      currentSiteId: '',
      keyword: ''
    }
  },
  computed: {
    getSites () {
      if (!this.detailInfo || !this.detailInfo.sites) return []
      let sites = this.detailInfo.sites
      if (this.keyword) {
        sites = sites.filter(s => s.name.includes(this.keyword))
      }
      return sites
    },
    getCurrentSite () {
      if (!this.currentSiteId) return null
      if (!this.detailInfo || !this.detailInfo.sites) return null
      return this.detailInfo.sites.find(s => s.id === this.currentSiteId)
    },
    getComponent () {
      return this.currentSiteId
        ? TrainingBatchSettingConfigureCustom
        : TrainingBatchSettingConfigure
    }
  },
  methods: {
    loadDetailInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/training/batch/setting/detailInfo',
        method: 'post',
        data: this.$qs.stringify({ batchId: this.batchId })
      }).then(response => {
        if (response.data && response.data.responseCode === 'SUCCESS') {
          this.detailInfo = response.data.detailInfo || {}
        } else {
          this.$message.warning(response.data.message)
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    onConfigureChange (siteId, configured) {
      if (!this.detailInfo || !this.detailInfo.sites) return
      const site = this.detailInfo.sites.find(s => s.id === siteId)
      if (site) {
        this.$set(site, 'configured', configured)
      }
    }
  },
  mounted () {
    this.loadDetailInfo()
  }
}
</script>

<style lang="scss">
.training-batch-setting-main {
  height: 100%;
  display: flex;
  align-items: stretch;
  & > .side {
    flex: none;
    width: 220px;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #ebeef5;
    & > .header {
      flex: none;
      padding: 10px;
      & > .batch-name {
        color: #303133;
        font-size: 12px;
        padding-left: 2px;
        margin-bottom: 10px;
        .label { color: #909399; }
        .name { font-weight: bold; }
      }
      & > .title {
        color: #303133;
        font-size: 12px;
        font-weight: bold;
        padding-left: 2px;
      }
      & > .empty {
        margin-top: 10px;
        .el-radio-group {
          display: block;
          .el-radio-button {
            display: block;
            .el-radio-button__inner {
              display: block;
              border-radius: 20px;
              padding: 7px 10px;
            }
          }
        }
      }
      & > .input {
        margin-top: 10px;
        .el-input {
          .el-input__inner {
            background-color: #f9f9f9;
            border-radius: 20px;
          }
        }
      }
    }
    & > .body {
      flex: auto;
      position: relative;
      & > .body-cont {
        position: absolute;
        left: 0; top: 0; right: 0; bottom: 0;
        .site-list {
          .el-radio-group {
            display: block;
            .el-radio-button {
              display: block;
              border-left: 2px solid transparent;
              .el-radio-button__inner {
                border: none;
                box-shadow: none;
                border-radius: 0;
                color: unset;
                text-align: unset;
                padding: 10px;
                background-color: unset;
                display: flex;
                align-items: center;
                & > .label { flex: auto; }
                & > .extra {
                  margin-left: 5px;
                  flex: none;
                  .el-tag { margin-top: -4px; margin-bottom: -4px; }
                }
              }
              & + .el-radio-button { margin-top: 1px; }
            }
          }
        }
      }
    }
  }
  & > .main {
    flex: auto;
    position: relative;
    & > .main-cont {
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
    }
  }
}
</style>
